import { Link } from 'react-router-dom';
import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            核心功能
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心功能模块，全面覆盖您的资源需求
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <Link
              key={index}
              to={feature.href}
              className="group p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}